<template>
  <div class="lmp-block clearBoth">
    <g-switch-list5
      :chip="chip"
      v-for="(d, i) in data.horizontal"
      :key="'h' + i"
      :title="d.title"
      :columns="1"
      :current="current"
      :list="d.list" />
  </div>

</template>

<script>
  import mixin from '../mixins';
  import GSwitchList5 from '../../c_game-switch/switch-list/g_switch-5'; // 纵向

  export default {
    name: "banbo",
    mixins: [mixin],
    components: {
      GSwitchList5
    },
    data() {
      console.log('banbo');
      return {};
    }
  }
</script>

<style scoped lang="stylus">
  .lmp-vertical
    margin-top 7px

  .lmp-vertical + .lmp-vertical
    margin-left 7px

  .lmp-vertical:nth-of-type(6)
    margin-left 0px
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/lh/banbo.vue